import { UseFormReturn } from 'react-hook-form';
import { useIntl } from 'react-intl';

import { Form } from 'src/registry/ui/Form';

import { voucherTypesMessages } from 'src/features/voucherTypes/utils/messages';
import { WebhookEndpointSchemaValues } from 'src/features/webhook-endpoints/utils/formSchema';
import InputFormField from 'src/registry/components/forms/InputFormField';
import { generalMessages } from 'src/utils/messages';
import { webhookEndpointsMessages } from 'src/features/webhook-endpoints/utils/messages';
import SelectFormField from 'src/registry/components/forms/SelectFormField';
import { BOOLEAN_MAP, BOOLEAN_OPTIONS } from 'src/features/moneyAccounts/utils/constants';
import TextareaFormField from 'src/registry/components/forms/TextareaFormField';
import MultiSelectField from 'src/registry/components/forms/MultiSelectFormField';
import { useGetWebhookTopics } from 'src/features/webhook-endpoints/api/useGetWebhookTopics';

type WebhookEndpointFormProps = {
    form: UseFormReturn<WebhookEndpointSchemaValues>;
    onSubmit: (values: WebhookEndpointSchemaValues) => void;
};

function WebhookEndpointForm({ onSubmit, form }: WebhookEndpointFormProps) {
    const { formatMessage } = useIntl();

    const { data: webhookTopics } = useGetWebhookTopics({});

    const topicsOptions =
        webhookTopics &&
        Object.keys(webhookTopics).map((option) => ({
            id: option,
            name: option,
        }));

    return (
        <Form form={form} onSubmit={form.handleSubmit(onSubmit)} variant="dialog">
            <InputFormField<WebhookEndpointSchemaValues>
                form={form}
                name="url"
                type="url"
                label={formatMessage(webhookEndpointsMessages.url)}
            />
            <TextareaFormField<WebhookEndpointSchemaValues>
                form={form}
                name="description"
                label={formatMessage(generalMessages.description)}
            />
            <SelectFormField<WebhookEndpointSchemaValues>
                form={form}
                name="is_active"
                isBoolean={true}
                required={false}
                label={formatMessage(voucherTypesMessages.isActive)}
                options={Object.values(BOOLEAN_OPTIONS)}
                optionTranslationMap={BOOLEAN_MAP}
            />
            <MultiSelectField<WebhookEndpointSchemaValues>
                form={form}
                name="topics"
                label={formatMessage(webhookEndpointsMessages.topics)}
                options={topicsOptions}
            />
        </Form>
    );
}

export default WebhookEndpointForm;
